import React from "react";
import { useTranslation } from "../hooks/useTranslation";

export const Services = () => {
  const { translate } = useTranslation();

  return (
    <div id="services" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>{translate("services_title")}</h2>
          <p>{translate("services_description")}</p>
        </div>
        <div className="row">
          <div className="col-md-4">
            <i className={translate("services_1_icon")}></i>
            <div className="service-desc">
              <h3>{translate("services_1_name")}</h3>
              <p>{translate("services_1_text")}</p>
            </div>
          </div>
          <div className="col-md-4">
            <i className={translate("services_2_icon")}></i>
            <div className="service-desc">
              <h3>{translate("services_2_name")}</h3>
              <p>{translate("services_2_text")}</p>
            </div>
          </div>
          <div className="col-md-4">
            <i className={translate("services_3_icon")}></i>
            <div className="service-desc">
              <h3>{translate("services_3_name")}</h3>
              <p>{translate("services_3_text")}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
